<ng-container *ngIf="loadingOptions; then loading else display"></ng-container>

<ng-template #loading>
  <p><i>Loading Information...</i></p>
</ng-template>

<ng-template #display>
  <div class="row">

    <!--
    <div class="col-sm-4">
      <input class="form-control" type="text" [(ngModel)]="stringValue" />
    </div>
    <div class="col-sm-4">
      <select class="form-control" [(ngModel)]="selectedOption" [ngModelOptions]="{standalone: true}">
          <option [ngValue]="null" selected="selected">-- Choose -- </option>
          <option *ngFor="let option of selectOptions" [ngValue]="option">
            {{option.mDisplay}}
          </option>
      </select>
    </div>
    -->


    <!--
    <span class="col-sm-6">
      <ng-container *ngIf="showDynamicOptions; then dynamicView else staticView"></ng-container>
      <ng-template #staticView>
        <input class="form-control" type="text" [(ngModel)]="stringValue" />
      </ng-template>
      <ng-template #dynamicView>
        <select class="form-control" [(ngModel)]="selectedOption" [ngModelOptions]="{standalone: true}">
          <option [ngValue]="null" selected="selected">-- Choose -- </option>
          <option *ngFor="let option of selectOptions" [ngValue]="option">
            {{option.mDisplay}}
          </option>
        </select>
      </ng-template>
    </span>
    <span class="col-sm-1">
      <input class="form-control" type="checkbox" [(ngModel)]="showDynamicOptions" />
    </span>
    <span class="col-sm-3">
      <label>Dynamic?</label>
    </span>
    -->


    <div class="col-sm-6">
      <ng-container *ngIf="showDynamicOptions; then dynamicView else staticView"></ng-container>
      <ng-template #staticView>
        <input class="form-control" type="text" [(ngModel)]="stringValue" />
      </ng-template>
      <ng-template #dynamicView>
        <select class="form-control" [(ngModel)]="selectedOption" [ngModelOptions]="{standalone: true}">
          <option [ngValue]="null" selected="selected">-- Choose -- </option>
          <option *ngFor="let option of selectOptions" [ngValue]="option">
            {{option.mDisplay}}
          </option>
        </select>
      </ng-template>
    </div>
    <label class="col-sm-1">Dynamic?</label>
    <div class="col-sm-1">
      <input class="form-control" type="checkbox" [(ngModel)]="showDynamicOptions" />
    </div>
    <div class="col-sm-2" *ngIf="showDynamicOptions">
      <h6><b><i>{{stringValue}}</i></b></h6>
    </div>
    

  </div>
</ng-template>
